import { useActor } from "@xstate/react";
import { Navigate } from "react-router-dom";
import { AuthState } from "@/js/xstate/auth.machine";
import { useState, useEffect } from "react";

export function ProtectedRoute({ roles, distributorSubtypes, currentPath, redirectUrl, children }) {
	const [authState] = useActor(AuthState);
	const [isReady, setIsReady] = useState(false);

	useEffect(() => {
		if (authState.context.type !== undefined) {
			setIsReady(true);
		}
	}, [authState.context.type]);

	if (!isReady) {
		return children;
	}

	const hasAccess =
		roles.includes(authState.context.type) ||
		(authState.context.type === "distributor" &&
			distributorSubtypes?.includes(authState.context.subtype));

	if (hasAccess) {
		return children;
	}

	if (!localStorage.getItem("sessionID")) {
		return <Navigate to="/auth" replace />;
	}

	return <Navigate to={redirectUrl} replace />;
}
